export default "__VITE_ASSET__73ddfc2f__"